module.exports = __webpack_public_path__ + "static/media/facebook-20160229-130742.04bb9e32.jpg";